import React from 'react'
import { ConnectorNameEnum, ConnectorName, Connector } from '@mprolab/sdk'
import Image from 'components/CompatImage'
import Metamask from '../../public/images/providers/Metamask.png'
import WalletConnect from '../../public/images/providers/WalletConnect.png'

export const connectors: Connector[] = [
  {
    title: ConnectorNameEnum.METAMASK,
    icon: <Image src={Metamask} />,
    connectorId: ConnectorName.Injected,
  },
  {
    title: ConnectorNameEnum.WALLETCONNECT,
    icon: <Image src={WalletConnect} />,
    connectorId: ConnectorName.WalletConnect,
  },
]

export default connectors
